<template>
  <v-container v-if="!containerInitLoading && customerGroup" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col style="max-width: 400px;">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="customerGroup"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, copy, editMode, handleFocus }">
            <CustomerGroupEditContent :originalItem="copy" :editItem="item" :editMode="editMode"
              :handleFocus="handleFocus">
            </CustomerGroupEditContent>
          </template>
        </EntityEditCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import CustomerGroupEditContent from "@/views/customer/group/CustomerGroupEditContent.vue";

export default {
  name: "ViewCustomerGroupInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    CustomerGroupEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      var copy = Object.assign({}, obj);
      copy.timeStamp = undefined;
      copy.loading = undefined;
      copy.silentloading = undefined;
      const file = copy.newImage;
      copy.newImage = undefined;
      const dto = Object.assign({}, copy);
      await this.changeCustomerGroup(dto, file)
        .then((response) => {
          this.customerGroup = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    customerGroup: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>